export * from './CONFLICT_APPLICATION.gql';
